<template>
  <div>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span v-if="code === 'secret'" class="headline">续费短效代理</span>
            <span v-else class="headline">续费隧道代理</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <form>
                <!--begin::Form Group-->
                <div v-if="code === 'secret'" class="form-group row">
                  <label class="col-xl-4 col-lg-3 col-form-label"
                    >每次提取IP数(个)</label
                  >
                  <div class="col-lg-8 col-xl-6">
                    <div>
                      <v-slider
                        v-model="form.product.ip_num"
                        disabled
                        class="align-center"
                        max="50"
                        min="10"
                        step="10"
                        hide-details
                      >
                        <template v-slot:append>
                          <v-text-field
                            v-model="form.product.ip_num"
                            disabled
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            step="10"
                            min="10"
                            max="50"
                            style="width: 60px"
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </div>
                  </div>
                </div>

                <div v-if="code === 'secret'" class="form-group row">
                  <label class="col-xl-4 col-lg-3 col-form-label"
                    >API 调用频率(秒)</label
                  >
                  <div class="col-lg-8 col-xl-6">
                    <div>
                      <v-slider
                        v-model.number="form.product.api_rate"
                        disabled
                        class="align-center"
                        max="10"
                        min="5"
                        step="5"
                        hide-details
                      >
                        <template v-slot:append>
                          <v-text-field
                            v-model.number="form.product.api_rate"
                            disabled
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            min="5"
                            max="10"
                            step="5"
                            style="width: 60px"
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </div>
                  </div>
                </div>

                <div v-if="code === 'tunnel'" class="form-group row">
                  <label class="col-xl-4 col-lg-3 col-form-label"
                    >每秒最大请求数</label
                  >
                  <div class="col-lg-8 col-xl-6">
                    <div>
                      <v-slider
                        v-model="form.product.qps"
                        disabled
                        class="align-center"
                        max="100"
                        min="5"
                        step="5"
                        hide-details
                      >
                        <template v-slot:append>
                          <v-text-field
                            v-model="form.product.qps"
                            disabled
                            class="mt-0 pt-0"
                            hide-details
                            single-line
                            type="number"
                            step="10"
                            min="5"
                            max="5"
                            style="width: 60px"
                          ></v-text-field>
                        </template>
                      </v-slider>
                    </div>
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-xl-3 col-lg-3 col-form-label"
                    >购买时长</label
                  >
                  <div class="col-lg-9 col-xl-6">
                    <b-form-group label="每个月按30天计算">
                      <b-form-radio-group
                        v-model="form.product.days"
                        buttons
                        button-variant="outline-primary"
                        class="mx-n1"
                        name="radio-btn-outline"
                      >
                        <template v-for="option in buyMessage.sales">
                          <b-form-radio :value="option.days" :key="option.name">
                            {{ option.name }}
                            <span
                              v-if="option.memo !== '不打折'"
                              class="product-sale"
                              >{{ option.memo }}</span
                            >
                          </b-form-radio>
                        </template>
                      </b-form-radio-group>
                    </b-form-group>
                  </div>
                </div>

                <div class="separator separator-dashed"></div>
                <!--begin::介绍-->
                <div class="form-group row mt-4">
                  <label class="col-xl-3 col-lg-3 col-form-label"
                    >增值服务</label
                  >
                  <div class="col-lg-9 col-xl-6 pt-6">
                    <span
                      >{{ serviceView.message }}
                      <a @click="showCollapse" class="text-primary">{{
                        serviceView.value
                      }}</a></span
                    >
                    <b-collapse :visible="visible" id="collapse-2">
                      <b-card>
                        <div class="row">
                          <p class="mb-1">支持高匿名代理</p>
                        </div>
                        <div class="row">
                          <p class="mb-1">支持白名单绑定</p>
                        </div>
                        <div class="row">
                          <p class="mb-1">支持代理类型HTTP(S)</p>
                        </div>
                        <div class="row">
                          <p class="mb-1">代理有效时长1~5分钟</p>
                        </div>
                        <div class="row">
                          <p class="mb-1">每天去重代理数>15万</p>
                        </div>
                        <div class="row">
                          <p class="mb-1">每天提取上限不限量</p>
                        </div>
                      </b-card>
                    </b-collapse>
                  </div>
                </div>

                <!--end:: 介绍-->

                <div class="separator separator-dashed my-5"></div>

                <div class="form-group row">
                  <label class="col-xl-3 col-lg-3 col-form-label">费用</label>
                  <div class="col-lg-9 col-xl-6">
                    <div class="row pt-1">
                      <span>
                        <del class="text-dark-50">{{ base_prices }}元</del>
                        <span class="text-danger text-h5 ml-4"
                          >{{ prices }}元</span
                        >
                      </span>
                    </div>
                  </div>
                </div>

                <div class="separator separator-dashed my-5"></div>

                <!--begin::Form Group-->
                <div class="form-group row">
                  <label class="col-xl-3 col-lg-3 col-form-label"
                    >支付方式</label
                  >
                  <div class="col-lg-9 col-xl-6" id="product-prices">
                    <b-form-group>
                      <b-form-radio-group
                        v-model="form.pay_type"
                        buttons
                        button-variant="outline-primary"
                        class="mx-n1"
                        name="radio-btn-outline"
                      >
                        <template v-for="option in buyMessage.pay_channels">
                          <b-form-radio
                            :value="option.type"
                            :key="option.type"
                            :disabled="option.disabled"
                          >
                            <span v-if="option.type === 'balance'">
                              <span v-if="prices > currentUserBalance"
                                >余额不足</span
                              >
                              <span v-else>余额: {{ currentUserBalance }}</span>
                            </span>
                            <span v-else v-html="option.html"></span>
                            <!--                            <span v-html="option.html"></span>-->
                          </b-form-radio>
                        </template>
                      </b-form-radio-group>
                    </b-form-group>
                  </div>
                </div>
              </form>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="white darken-1" @click="closeDialog">关闭</v-btn>
            <v-btn color="primary" dark @click="userBuy">续费</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <Qrcode
      v-bind:dialog.sync="qrcodeDialog"
      :orderResultData="orderResultData"
    ></Qrcode>
    <PaySuccess
      v-if="paySuccessDialog"
      v-bind:dialog.sync="paySuccessDialog"
      :order="order"
    ></PaySuccess>
  </div>
</template>

<script>
import { getInstance, postInstance } from "@/api/instance";
import { fetchBuyMessage } from "@/api/message";
import { postSumPrices } from "@/api/pay";
import Qrcode from "@/view/pages/pay/Qrcode";
import PaySuccess from "@/view/pages/pay/PaySuccess";
import { mapGetters } from "vuex";

export default {
  name: "Renew",
  components: {
    Qrcode,
    PaySuccess,
  },
  computed: {
    ...mapGetters(["currentUserBalance"]),
  },
  props: {
    form: {
      type: Object,
      required: true,
      default: () => {
        return {
          action: "renew",
          pay_type: "weixin",
          product: {},
        };
      },
    },
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    code: {
      type: String,
      required: true,
    },
  },
  watch: {
    form: {
      handler: function () {
        this.sumPrices();
      },
      deep: true,
    },
  },
  data() {
    return {
      qrcodeDialog: false,
      paySuccessDialog: false,
      visible: false,
      serviceView: {
        message: "支持白名单绑定等多项服务",
        value: "展开",
      },
      buyMessage: {
        pay_channels: [],
        products: [],
        sales: [],
      },
      balance: 0,
      orderResultData: {
        order_id: "",
        url: "",
        pay_type: "",
      },
      prices: 0,
      base_prices: 0,
      order: {},
      ticksLabels: ["10个", "20个", "30个", "40个", "50个"],
    };
  },
  created() {
    fetchBuyMessage().then((res) => {
      this.buyMessage = res.result;
    });
  },
  methods: {
    showCollapse() {
      this.visible = !this.visible;
      if (this.visible) {
        this.serviceView.message = "";
        this.serviceView.value = "收起";
      } else {
        this.serviceView.message = "支持白名单绑定等多项服务";
        this.serviceView.value = "展开";
      }
    },
    sumPrices() {
      postSumPrices(this.form).then((res) => {
        this.prices = res.result.prices / 100;
        this.base_prices = res.result.base_prices / 100;
        for (let channel of this.buyMessage.pay_channels) {
          if (channel.type === "balance") {
            channel.disabled = this.prices > this.currentUserBalance;
          }
        }
      });
    },
    userBuy() {
      postInstance("ORDER", this.form).then((res) => {
        if (this.form.pay_type === "balance") {
          this.fetchOrderAndOpenDialog(res.result.order_id);
        } else {
          this.orderResultData = res.result;
          this.qrcodeDialog = true;
        }
      });
    },
    closeDialog() {
      this.$emit("update:dialog", false);
    },
    fetchOrderAndOpenDialog(order_id) {
      getInstance("ORDER", { _id: order_id }).then((res) => {
        this.order = res.result[0];
        this.paySuccessDialog = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.product-sale {
  position: absolute;
  top: -8px;
  right: 0;
  background-color: orange;
  color: #fff;
  font-size: 10px;
  height: 16px;
  padding: 1px 3px;
}
</style>
